import React, {useContext} from 'react'
import AdminDashboardSection from "../role/admin/AdminDashboardSection";
import {FirebaseAuthContext} from "../../../../commons/firebase/FirebaseAuthProvider";
import ContentCreatorDashboardSection from "../role/contentCreator/ContentCreatorDashboardSection";
import PlayerDashboardSection from "../role/player/PlayerDashboardSection";
import {Redirect} from "react-router-dom";
import OrganizerDashboardSection from "../role/organizer/OrganizerDashboardSection";


const DashboardGate = () => {
    const {signedInUserRole, signedInUserRoleScopes} = useContext(FirebaseAuthContext)
    const profileDataIncomplete = signedInUserRoleScopes?.length === 0

    // Redirect the user to the edit profile page to complete his/her user data
    if (profileDataIncomplete) {
        return <Redirect to={"/common/profile/edit"}/>;
    }

    if (signedInUserRole === 'admin') {
        return <AdminDashboardSection/>
    }

    if (signedInUserRole === 'contentCreator') {
        return <ContentCreatorDashboardSection/>
    }

    if (signedInUserRole === 'player') {
        return <PlayerDashboardSection/>
    }

    if (signedInUserRole === 'organizer') {
        return <OrganizerDashboardSection/>
    }

}

export default DashboardGate
